import keyBy from 'lodash/keyBy';
import type { RefObject } from 'react';
import { useEffect } from 'react';
import type { DataSourceRecordStoreInstance } from './DataSourceRecordStoreManager';
import type { DataSourceRecordStoreRefType } from './types';

const SKIP_SYNC_TRACKING = true;

export function useDataSourceRecordStoreImperativeRef({
  store,
  dataSourceRecordStoreRef,
}: {
  store: DataSourceRecordStoreInstance;
  dataSourceRecordStoreRef?: RefObject<DataSourceRecordStoreRefType | undefined>;
}) {
  useEffect(() => {
    if (!dataSourceRecordStoreRef) return;

    dataSourceRecordStoreRef.current = {
      updateDataSources: ({ added, changed, deleted }) => {
        const { actions } = store.getState();
        const upserts = [...added, ...changed];

        if (upserts.length) {
          actions.setDataSources(keyBy(upserts, 'id'));
        }

        for (const dataSource of deleted) {
          actions.removeDataSource(dataSource.id, SKIP_SYNC_TRACKING);
        }
      },
    };
  }, [dataSourceRecordStoreRef, store]);
}
